(function () {
  /* ==========================================================================
     Mixunio · Frostline theme — behaviour (classic script, no modules).
     Liquid renders all content; this file only enriches it.
     ========================================================================== */
  "use strict";

  var WS = window.WS || {};
  var NAV_OFFSET = 88;

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function safe(fn, name) { try { fn(); } catch (e) { if (window.console) console.warn("[" + name + "]", e); } }
  var finePointer = window.matchMedia && window.matchMedia("(hover: hover) and (pointer: fine)").matches;

  function money(cents) {
    var fmt = WS.moneyFormat || "${{amount}}";
    var n = Math.round(Number(cents) || 0);
    function withDelims(num, dec, th, ds) {
      var parts = (num / 100).toFixed(dec).split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return parts[0] + (parts[1] ? ds + parts[1] : "");
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case "amount_no_decimals": return withDelims(n, 0, ",", ".");
        case "amount_with_comma_separator": return withDelims(n, 2, ".", ",");
        case "amount_no_decimals_with_comma_separator": return withDelims(n, 0, ".", ",");
        case "amount_with_apostrophe_separator": return withDelims(n, 2, "'", ".");
        default: return withDelims(n, 2, ",", ".");
      }
    });
  }

  /* ---------------- toast ---------------- */
  var toastTimer = null;
  function toast(msg) {
    var t = $("#toast");
    if (!t) return;
    t.textContent = msg;
    t.classList.add("is-on");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove("is-on"); }, 2800);
  }

  /* ---------------- anchors (native smooth scroll) ---------------- */
  function scrollToEl(el) {
    if (!el) return;
    var y = el.getBoundingClientRect().top + window.pageYOffset - NAV_OFFSET;
    window.scrollTo({ top: Math.max(0, y), behavior: "smooth" });
  }
  function initAnchors() {
    document.addEventListener("click", function (e) {
      var a = e.target.closest ? e.target.closest('a[href^="#"]') : null;
      if (!a) return;
      var id = a.getAttribute("href").slice(1);
      var el = id && document.getElementById(id);
      if (!el) return;
      e.preventDefault();
      scrollToEl(el);
    });
    if (location.hash && location.hash.length > 1) {
      var target = document.getElementById(location.hash.slice(1));
      if (target) setTimeout(function () { scrollToEl(target); }, 150);
    }
  }

  /* ---------------- nav underline that slides between links ---------------- */
  function initNavLine() {
    var wrap = $(".nav__links");
    var line = $(".nav__line");
    if (!wrap || !line) return;
    function moveTo(a) {
      line.style.width = a.offsetWidth + "px";
      line.style.transform = "translateX(" + a.offsetLeft + "px)";
      line.style.opacity = "1";
    }
    $$("a", wrap).forEach(function (a) {
      a.addEventListener("mouseenter", function () { moveTo(a); });
      a.addEventListener("focus", function () { moveTo(a); });
    });
    wrap.addEventListener("mouseleave", function () { line.style.opacity = "0"; });
  }

  /* ---------------- magnetic CTA (subtle) ---------------- */
  function initMagnetic() {
    if (!finePointer) return;
    $$(".magnetic").forEach(function (b) {
      if (b.getAttribute("data-mag")) return;
      b.setAttribute("data-mag", "1");
      b.addEventListener("mousemove", function (e) {
        var r = b.getBoundingClientRect();
        var x = (e.clientX - r.left - r.width / 2) * 0.2;
        var y = (e.clientY - r.top - r.height / 2) * 0.2;
        b.style.transform = "translate(" + x + "px," + y + "px)";
      });
      b.addEventListener("mouseleave", function () { b.style.transform = ""; });
    });
  }

  /* ---------------- buy bar + nav ---------------- */
  function initScrollUi() {
    var bar = $("#buybar");
    var buy = $("#buy");
    var hero = $(".hero") || $(".pdp-top");
    var barLink = bar ? $("a", bar) : null;
    var ticking = false;
    function update() {
      ticking = false;
      if (!bar) return;
      if (!buy) { bar.style.display = "none"; return; }
      var vh = window.innerHeight;
      var b = buy.getBoundingClientRect();
      var buyVisible = b.top < vh * 0.85 && b.bottom > vh * 0.15;
      var pastTop = hero ? hero.getBoundingClientRect().bottom < 60 : window.pageYOffset > vh;
      var on = pastTop && !buyVisible;
      bar.classList.toggle("is-on", on);
      bar.setAttribute("aria-hidden", on ? "false" : "true");
      if (barLink) barLink.setAttribute("tabindex", on ? "0" : "-1");
    }
    function onScroll() { if (!ticking) { ticking = true; window.requestAnimationFrame(update); } }
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    update();
  }

  /* ---------------- reveals (threshold 0.01 + 6 s safety net) ---------------- */
  function initReveals() {
    var els = $$(".reveal:not(.is-in)");
    document.documentElement.classList.add("reveal-ready");
    if (!("IntersectionObserver" in window) || (window.Shopify && window.Shopify.designMode)) {
      els.forEach(function (el) { el.classList.add("is-in"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add("is-in"); io.unobserve(en.target); }
      });
    }, { threshold: 0.01, rootMargin: "0px 0px -6% 0px" });
    els.forEach(function (el) { io.observe(el); });
    setTimeout(function () {
      var vh = window.innerHeight;
      els.forEach(function (el) {
        if (!el.classList.contains("is-in") && el.getBoundingClientRect().top < vh) el.classList.add("is-in");
      });
    }, 6000);
  }

  /* ---------------- counters ---------------- */
  function initCounters() {
    var nums = $$("[data-count]");
    if (!nums.length || !("IntersectionObserver" in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        io.unobserve(en.target);
        var el = en.target;
        var to = parseFloat(el.getAttribute("data-count")) || 0;
        var start = null, dur = 1300;
        function step(ts) {
          if (!start) start = ts;
          var p = Math.min(1, (ts - start) / dur);
          var e = 1 - Math.pow(1 - p, 3);
          el.textContent = Math.round(to * e);
          if (p < 1) window.requestAnimationFrame(step); else el.textContent = to;
        }
        window.requestAnimationFrame(step);
      });
    }, { threshold: 0.01 });
    nums.forEach(function (n) { io.observe(n); });
  }

  /* ---------------- frost you can wipe off (hero) ---------------- */
  function initFrost() {
    $$("[data-frost]").forEach(function (box) {
      if (box.getAttribute("data-ready")) return;
      var canvas = $(".frost__canvas", box);
      if (!canvas || !canvas.getContext) return;
      var ctx = canvas.getContext("2d");
      if (!ctx) return;
      box.setAttribute("data-ready", "1");
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      var W = 0, H = 0, brush = 40, moves = 0, cleared = false, last = null;

      function rand(a, b) { return a + Math.random() * (b - a); }
      function fern(x, y, len, ang, depth) {
        if (depth <= 0 || len < 3) return;
        var x2 = x + Math.cos(ang) * len, y2 = y + Math.sin(ang) * len;
        ctx.beginPath(); ctx.moveTo(x, y); ctx.lineTo(x2, y2); ctx.stroke();
        var n = 3;
        for (var i = 1; i <= n; i++) {
          var px = x + (x2 - x) * (i / (n + 1)), py = y + (y2 - y) * (i / (n + 1));
          fern(px, py, len * 0.42, ang - 1.05, depth - 1);
          fern(px, py, len * 0.42, ang + 1.05, depth - 1);
        }
        fern(x2, y2, len * 0.55, ang + rand(-0.3, 0.3), depth - 1);
      }
      function paintFrost() {
        var r = canvas.getBoundingClientRect();
        W = Math.max(1, Math.round(r.width * dpr)); H = Math.max(1, Math.round(r.height * dpr));
        canvas.width = W; canvas.height = H;
        brush = Math.max(28, Math.round(Math.min(W, H) * 0.085));
        ctx.globalCompositeOperation = "source-over";
        var g = ctx.createLinearGradient(0, 0, W, H);
        g.addColorStop(0, "rgba(236,244,252,0.94)");
        g.addColorStop(0.5, "rgba(214,229,246,0.92)");
        g.addColorStop(1, "rgba(232,238,250,0.95)");
        ctx.fillStyle = g; ctx.fillRect(0, 0, W, H);
        // speckle
        for (var i = 0; i < (W * H) / 900; i++) {
          ctx.fillStyle = "rgba(255,255,255," + rand(0.2, 0.7).toFixed(2) + ")";
          ctx.fillRect(rand(0, W), rand(0, H), rand(0.6, 2) * dpr, rand(0.6, 2) * dpr);
        }
        // ice ferns
        ctx.lineCap = "round";
        for (var k = 0; k < 26; k++) {
          ctx.strokeStyle = "rgba(255,255,255," + rand(0.35, 0.75).toFixed(2) + ")";
          ctx.lineWidth = rand(0.6, 1.5) * dpr;
          var edge = Math.random();
          var sx = edge < 0.5 ? rand(0, W) : (Math.random() < 0.5 ? 0 : W);
          var sy = edge < 0.5 ? (Math.random() < 0.5 ? 0 : H) : rand(0, H);
          var ang = Math.atan2(H / 2 - sy, W / 2 - sx) + rand(-0.6, 0.6);
          fern(sx, sy, rand(0.12, 0.26) * Math.min(W, H), ang, 3);
        }
        cleared = false; moves = 0; last = null;
        box.classList.remove("is-clear");
        canvas.style.transition = ""; canvas.style.opacity = "1";
      }
      function wipe(x, y) {
        ctx.globalCompositeOperation = "destination-out";
        function dab(px, py) {
          var g = ctx.createRadialGradient(px, py, 0, px, py, brush);
          g.addColorStop(0, "rgba(0,0,0,1)");
          g.addColorStop(0.6, "rgba(0,0,0,0.85)");
          g.addColorStop(1, "rgba(0,0,0,0)");
          ctx.fillStyle = g;
          ctx.beginPath(); ctx.arc(px, py, brush, 0, Math.PI * 2); ctx.fill();
        }
        if (last) {
          var dx = x - last.x, dy = y - last.y, d = Math.sqrt(dx * dx + dy * dy), steps = Math.max(1, Math.floor(d / (brush * 0.35)));
          for (var s = 1; s <= steps; s++) dab(last.x + dx * s / steps, last.y + dy * s / steps);
        } else dab(x, y);
        last = { x: x, y: y };
        if (++moves % 12 === 0) checkCleared();
      }
      function checkCleared() {
        if (cleared) return;
        try {
          var data = ctx.getImageData(0, 0, W, H).data, see = 0, total = 0;
          for (var i = 3; i < data.length; i += 4 * 61) { total++; if (data[i] < 60) see++; }
          if (see / total > 0.5) clearAll();
        } catch (e) { /* ignore */ }
      }
      function clearAll() {
        cleared = true;
        canvas.style.transition = "opacity 0.9s ease";
        canvas.style.opacity = "0";
        box.classList.add("is-clear");
        // the frost comes back a while later, like the next night
        setTimeout(function () {
          if (!box.matches(":hover")) { canvas.style.transition = "none"; paintFrost(); canvas.style.opacity = "0"; void canvas.offsetWidth; canvas.style.transition = "opacity 1.6s ease"; canvas.style.opacity = "1"; box.classList.remove("is-touched"); }
        }, 9000);
      }
      function pos(e) {
        var r = canvas.getBoundingClientRect();
        return { x: (e.clientX - r.left) * dpr, y: (e.clientY - r.top) * dpr };
      }
      var down = false;
      canvas.addEventListener("pointerdown", function (e) { down = true; last = null; box.classList.add("is-touched"); var p = pos(e); wipe(p.x, p.y); });
      canvas.addEventListener("pointermove", function (e) {
        if (!down && e.pointerType !== "mouse") return;
        box.classList.add("is-touched");
        var p = pos(e); wipe(p.x, p.y);
      });
      ["pointerup", "pointercancel", "pointerleave"].forEach(function (ev) {
        canvas.addEventListener(ev, function () { down = false; last = null; });
      });

      // A first wipe drawn by itself, so people see it is interactive
      function demo() {
        if (box.classList.contains("is-touched")) return;
        var t0 = null, dur = 1400;
        last = null;
        function step(ts) {
          if (box.classList.contains("is-touched")) { last = null; return; }
          if (!t0) t0 = ts;
          var p = Math.min(1, (ts - t0) / dur);
          var x = W * (0.2 + 0.6 * p);
          var y = H * (0.42 + Math.sin(p * Math.PI * 2) * 0.06);
          wipe(x, y);
          if (p < 1) window.requestAnimationFrame(step); else last = null;
        }
        window.requestAnimationFrame(step);
      }

      paintFrost();
      var rT = null, lastW = canvas.getBoundingClientRect().width;
      window.addEventListener("resize", function () {
        clearTimeout(rT);
        rT = setTimeout(function () {
          var w = canvas.getBoundingClientRect().width;
          if (Math.abs(w - lastW) > 2) { lastW = w; paintFrost(); }
        }, 200);
      });
      if ("IntersectionObserver" in window) {
        var io = new IntersectionObserver(function (en) {
          if (en[0].isIntersecting) { io.disconnect(); setTimeout(demo, 900); }
        }, { threshold: 0.2 });
        io.observe(box);
      } else setTimeout(demo, 900);
    });
  }

  /* ---------------- cart count ---------------- */
  function setCartCount(n) {
    $$("[data-cart-count]").forEach(function (el) {
      el.textContent = n;
      if (n > 0) el.removeAttribute("hidden"); else el.setAttribute("hidden", "");
    });
  }

  /* When the product isn't chosen in theme settings: find the cover in the public catalog */
  function findCoverVariant(root) {
    return fetch(root + "products.json?limit=250", { headers: { "Accept": "application/json" } })
      .then(function (r) { if (!r.ok) throw new Error("Could not load the product"); return r.json(); })
      .then(function (data) {
        var products = (data && data.products) || [];
        for (var p = 0; p < products.length; p++) {
          var t = (products[p].title || "").toLowerCase();
          if (t.indexOf("windshield") === -1 && t.indexOf("snow cover") === -1) continue;
          var vs = products[p].variants || [];
          for (var i = 0; i < vs.length; i++) if (vs[i].available !== false) return vs[i].id;
        }
        throw new Error("The cover is sold out right now. Please check back soon.");
      });
  }

  /* ---------------- buy box: cover × number of cars ---------------- */
  function initBuy() {
    var form = $("#builder");
    if (!form || form.getAttribute("data-ready") === "1") return;
    form.setAttribute("data-ready", "1");

    var cfg = {};
    var cfgEl = $("[data-ws-buy]", form);
    try { cfg = cfgEl ? JSON.parse(cfgEl.textContent) : {}; } catch (e) { cfg = {}; }

    var packs = $$('input[name="pack"]', form);
    if (!packs.length) return;
    var totalEl = $(".js-total", form);
    var regularEl = $(".js-regular", form);
    var saveEl = $(".js-save", form);
    var btn = $("#buy-btn");
    var barTitle = $(".js-bar-title");
    var barSub = $(".js-bar-sub");
    var busy = false;

    function pack() { return packs.filter(function (i) { return i.checked; })[0] || packs[0]; }
    function variantInput() {
      var radios = $$('input[name="variant"][type="radio"]', form);
      if (radios.length) return radios.filter(function (i) { return i.checked; })[0] || radios[0];
      return $('input[name="variant"]', form);
    }

    function render() {
      var p = pack();
      var n = parseInt(p.value, 10) || 1;
      var v = variantInput();
      var unit = parseInt(v && v.getAttribute("data-price"), 10) || 0;
      var price = n === 1 ? unit : (parseInt(p.getAttribute("data-price"), 10) || unit * n);
      var regular = unit * n;
      var saving = regular - price;
      var label = p.getAttribute("data-label") || "";
      if (totalEl) totalEl.textContent = money(price);
      if (regularEl) { regularEl.textContent = money(regular); regularEl.style.display = saving > 0 ? "" : "none"; }
      if (saveEl) saveEl.textContent = saving > 0 ? "You save " + money(saving) + " · free US shipping" : "Free US shipping · 30-day returns";
      if (btn && !busy) btn.textContent = "Add " + (n === 1 ? "1 cover" : n + " covers") + " · " + money(price);
      if (barTitle) barTitle.textContent = label + " · " + money(price);
      if (barSub) barSub.textContent = n === 1 ? "Free US shipping" : n + " covers · free US shipping";
    }

    function goNext(code) {
      var root = (cfg.root || "/").replace(/\/?$/, "/");
      var dest = cfg.after === "cart" ? root + "cart" : "/checkout";
      if (code) window.location.href = root + "discount/" + encodeURIComponent(code) + "?redirect=" + encodeURIComponent(dest);
      else window.location.href = dest;
    }

    packs.forEach(function (i) { i.addEventListener("change", render); });
    $$('input[name="variant"][type="radio"]', form).forEach(function (i) { i.addEventListener("change", render); });

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      if (busy) return;
      var p = pack();
      var n = parseInt(p.value, 10) || 1;
      var code = p.getAttribute("data-code") || "";
      var root = (cfg.root || "/").replace(/\/?$/, "/");
      var v = variantInput();
      busy = true;
      if (btn) { btn.textContent = "Adding to cart…"; btn.setAttribute("aria-busy", "true"); }
      var getId = cfg.ready && v && v.value ? Promise.resolve(parseInt(v.value, 10)) : findCoverVariant(root);
      getId.then(function (id) {
        return fetch(root + "cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", "Accept": "application/json" },
          body: JSON.stringify({ items: [{ id: id, quantity: n }] })
        });
      }).then(function (r) {
        return r.json().then(function (data) { return { ok: r.ok, data: data }; });
      }).then(function (res) {
        if (!res.ok) throw new Error((res.data && (res.data.description || res.data.message)) || "Could not add to cart");
        toast("Added. Taking you to " + (cfg.after === "cart" ? "your cart" : "checkout") + "…");
        goNext(code);
      }).catch(function (err) {
        busy = false;
        if (btn) btn.removeAttribute("aria-busy");
        render();
        toast(err && err.message ? err.message : "Something went wrong. Please try again.");
      });
    });

    window.addEventListener("pageshow", function (ev) { if (ev.persisted) { busy = false; render(); } });
    render();
  }

  /* ---------------- product gallery ---------------- */
  function initGallery() {
    $$("[data-gallery]").forEach(function (g) {
      if (g.getAttribute("data-ready")) return;
      g.setAttribute("data-ready", "1");
      var main = $(".pgal__img", g);
      $$("[data-thumb]", g).forEach(function (b) {
        b.addEventListener("click", function () {
          if (!main) return;
          main.removeAttribute("srcset");
          main.src = b.getAttribute("data-src");
          main.alt = b.getAttribute("data-alt") || "";
          $$("[data-thumb]", g).forEach(function (o) { o.setAttribute("aria-current", o === b ? "true" : "false"); });
        });
      });
    });
  }

  function initVariantSelect() {
    $$("[data-variant-select]").forEach(function (sel) {
      sel.addEventListener("change", function () {
        var opt = sel.options[sel.selectedIndex];
        var info = sel.closest(".pdp__info");
        var priceEl = info ? $("[data-price]", info) : null;
        if (opt && priceEl) priceEl.textContent = opt.getAttribute("data-price");
      });
    });
  }

  function initFaq() {
    var items = $$(".faq details");
    items.forEach(function (d) {
      d.addEventListener("toggle", function () {
        if (!d.open) return;
        items.forEach(function (o) { if (o !== d && o.closest(".faq") === d.closest(".faq")) o.open = false; });
      });
    });
  }

  function boot() {
    safe(initAnchors, "initAnchors");
    safe(initNavLine, "initNavLine");
    safe(initMagnetic, "initMagnetic");
    safe(initScrollUi, "initScrollUi");
    safe(initReveals, "initReveals");
    safe(initCounters, "initCounters");
    safe(initFrost, "initFrost");
    safe(initBuy, "initBuy");
    safe(initGallery, "initGallery");
    safe(initVariantSelect, "initVariantSelect");
    safe(initFaq, "initFaq");
    safe(function () { setCartCount(WS.cartCount || 0); }, "cartCount");
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();

  document.addEventListener("shopify:section:load", function () {
    safe(initReveals, "initReveals");
    safe(initCounters, "initCounters");
    safe(initFrost, "initFrost");
    safe(initBuy, "initBuy");
    safe(initGallery, "initGallery");
    safe(initMagnetic, "initMagnetic");
  });
})();
